import BaseServiceCrud from './BaseServiceCrud';

export default class ReminderService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'reminder';
    }
    getCriteria(criteria) {
        return this.objToQueryString({});
    }

    markAsRead(reminder) {
        return this.fetch(`${this.domain}/${this.path}/mark-as-read/${reminder.id}`, {
            method: 'PATCH',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
